"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Loading_1 = require("./Loading");
exports.default = Loading_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Loading/index.js
// module id = 526
// module chunks = 8